$(document).ready(function (e) {
    if ($('.icp-retailer-field').length > 0) {
        $('input.icp-number-field').each(function(){
            $(this).on('change', function () {
                if ($(this).val().length == 15) {
                    icpNumber = $(this).val();

                    url = window.location.href;

                    if (url.endsWith('/')){
                        url = url.slice(0, -1);
                    }

                    url = url.replace(/\/?$/, "/") + '/getICPRetailer'

                    $.ajax({
                        type: "GET",
                        url: url,
                        data: {
                            icpNumber: icpNumber
                        },
                        success: function (response) {
                            icpField = $('input.icp-retailer-field')
                            icpField.attr('value', response);
                            icpField.val(response);
                        }
                    });
                }
            })
        })
    }
});